@if (showNotes) {
	<div class="form-group">
		<app-textarea [formControl]="notesControl" label="Notes" placeholder="text..."></app-textarea>
	</div>
}